import React from 'react'
import {SlotComponent} from '../../types/ui'
import {Stack} from '../../vanilla'
import LazyLoad from 'react-lazyload'
import {Recommender} from '../recommendations'
import {ProductCategoryCarousel} from '../product-category-carousel'
import { ProductCarouselProps } from '../../types/cms'

export const ProductMerchandisingCarousel: SlotComponent<ProductCarouselProps> = ({content}) => {
  if (!content) {
    return null
  }
  const {recommenderCarousel, productCategoryCarousel} = content
  return (
    <Stack>
      {recommenderCarousel?.showRecommender && recommenderCarousel?.einstein &&  (
        <LazyLoad once>
          <Recommender
            name={recommenderCarousel?.title}
            recommender={recommenderCarousel?.einstein?.recommenderId ?? ''}
            categoryId={recommenderCarousel?.category?.id}
          />
        </LazyLoad>
      )}
      {productCategoryCarousel?.showProductCategoryCarousel && (
        <ProductCategoryCarousel
          title={productCategoryCarousel?.title}
          categoryId={productCategoryCarousel?.category?.id}
        />
      )}
    </Stack>
  )
}
